import { render } from "./Approach.vue?vue&type=template&id=2d694a96"
import script from "./Approach.vue?vue&type=script&lang=js"
export * from "./Approach.vue?vue&type=script&lang=js"

import "./Approach.vue?vue&type=style&index=0&id=2d694a96&lang=css"
script.render = render

export default script